import styled, { css } from 'styled-components';
import { ReactComponent as CopyFile } from '../../assets/icons/copy-file.svg';
import { ReactComponent as Printer } from '../../assets/icons/printer.svg';

interface inputProps {
  valid?: boolean;
  filled?: boolean;
}

interface ImgsProps {
  homeImg?: string;
  homeMobileImg?: string;
  assessoriaImg?: string;
  step?: number;
  billetsQuantity?: number;
}

export const Wrapper = styled.div<ImgsProps>`
  height: ${({ step, assessoriaImg }) => {
    if (step === 1) {
      return assessoriaImg ? '576px' : '445px';
    }
    return '100%';
  }};
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => (props.step === 1 ? props.theme.colors.fontColor : '')};
  background: ${({ step }) =>
    step === 1 ? (props) => props.theme.colors.primaryDark1 : ''};

  padding: 32px 20px;

  ${({ homeImg }) =>
    homeImg &&
    css`
      background: url(${homeImg}) no-repeat center;
      background-size: cover;
    `}

  ${({ homeMobileImg }) =>
    homeMobileImg &&
    css`
      @media screen and (max-width: 960px) {
        background: url(${homeMobileImg}) no-repeat center;
        background-size: cover;
      }
    `}

  h1 {
    font-size: 40px;
    font-weight: 700;
    margin-bottom: 20px;
  }

  p {
    font-size: ${({ billetsQuantity }) =>
      billetsQuantity === 1 ? '16px' : '22px'};
    font-weight: 400;
    margin-bottom: 32px;
  }
  @media (max-width: 960px) {
    padding: 32px 20px;

    h1 {
      font-size: 28px;
    }

    p {
      font-size: ${({ billetsQuantity }) =>
        billetsQuantity === 1 ? '16px' : '20px'};
    }

    img {
      width: 200px;
    }
  }
`;
export const BilletContainer = styled.div<ImgsProps>`
  height: ${({ step }) => (step === 1 ? '441px' : '100%')};
  font-size: 22px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.theme.colors.fontColor};
  background: ${(props) => props.theme.colors.lightGray};
  padding: 32px 20px;

  ${({ homeImg }) =>
    homeImg &&
    css`
      background: url(${homeImg}) no-repeat center;
      background-size: cover;
    `}

  ${({ homeMobileImg }) =>
    homeMobileImg &&
    css`
      @media screen and (max-width: 960px) {
        background: url(${homeMobileImg}) no-repeat center;
        background-size: cover;
      }
    `}

  h1 {
    font-size: 40px;
    font-weight: 700;
    margin-bottom: 20px;
  }

  p {
    font-size: 22px;
    font-weight: 400;
    margin-bottom: 32px;
  }
  @media (max-width: 960px) {
    padding: 32px 20px;
    height: auto;

    h1 {
      font-size: 28px;
    }

    p {
      font-size: 20px;
    }

    img {
      width: 200px;
    }
  }
`;
export const Container = styled.div`
  width: 624px;
  padding: 20px;

  @media screen and (max-width: 960px) {
    width: 100%;
  }
`;
export const Subtitle = styled.h2`
  font-weight: 400;
  font-size: 16px;
  color: ${(props) => props.theme.colors.black};
  text-align: center;
  margin-bottom: 28px;

  @media screen and (max-width: 960px) {
    font-size: 16px;
    margin-bottom: 28px;
  }
`;

export const Main = styled.div`
  width: 1200px;
  display: flex;
  justify-content: space-between;

  @media (max-width: 960px) {
    flex-direction: column;
    width: 100%;
  }
`;

export const LeftContainer = styled.div<ImgsProps>`
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  margin-top: ${({ assessoriaImg }) => (assessoriaImg ? '24px' : '-52px')};

  @media (max-width: 960px) {
    width: 100%;
    align-items: initial;
    justify-content: initial;
    padding-left: 0;
    margin-top: ${({ assessoriaImg }) => (assessoriaImg ? '100px' : '30px')};
    margin-bottom: ${({ assessoriaImg }) => (assessoriaImg ? '0px' : '34px')};
  }
`;

export const Description = styled.div`
  @media (max-width: 960px) {
    display: flex;
    flex-direction: column;
  }
`;

export const Card = styled.div`
  width: 100%;
  background: ${(props) => props.theme.colors.white};
  box-shadow: -2px -2px 6px rgba(255, 255, 255, 0.8),
    4px 4px 6px rgba(36, 36, 36, 0.1);
  border-radius: ${(props) =>
    Number(props.theme.radiusCards) ? `${props.theme.radiusCards}px` : '60px'};

  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
  padding: 20px 40px;
  color: ${(props) => props.theme.colors.gray};
  cursor: pointer;
  margin-bottom: 12px;
`;

export const Date = styled.div`
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.colors.gray};
  margin: 6px 0;
`;

export const Title = styled.div`
  color: ${(props) => props.theme.colors.primaryDark1};
  font-size: 30px;
  display: flex;
  align-items: center;
  font-weight: bold;
  justify-content: center;
  width: 100%;
  margin-bottom: 10px;
`;

export const CardContent = styled.div`
  display: flex;
  justify-content: space-between;
`;
export const DateContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-left: 5px;
`;
export const BilletValue = styled.div`
  font-size: 25px;
  font-weight: 400;

  color: ${(props) => props.theme.colors.primary};
`;
export const CardContainer = styled.div`
  width: 100%;
  height: 100%;
  background: ${(props) => props.theme.colors.white};
  box-shadow: -4px -4px 8px rgba(255, 255, 255, 0.8),
    4px 4px 6px rgba(36, 36, 36, 0.1);
  border-radius: ${(props) =>
    Number(props.theme.radiusCards) ? `${props.theme.radiusCards}px` : '60px'};

  display: flex;
  justify-content: center;
  flex-direction: column;
  /* justify-content: space-between; */
  padding: 20px 40px;
  color: ${(props) => props.theme.colors.gray};
  cursor: pointer;
  margin-bottom: 15px;

  .left {
    display: flex;
    flex-direction: column;
  }

  .right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }

  .portion {
    font-weight: 900;
    font-size: 14px;
    color: ${(props) => props.theme.colors.primaryDark2};
    display: flex;

    #icon {
      display: block;
      margin-right: 2px;
      margin-top: -2px;
    }
  }

  .default {
    font-weight: 400;
    font-size: 12px;
    line-height: 18.2px;
  }

  .price {
    font-weight: 700;
    font-size: 20px;
    color: ${(props) => props.theme.colors.primaryDark2};
    line-height: 24.14px;
    display: flex;

    span {
      display: none;
      margin-right: 4px;
    }
  }

  .text {
    font-weight: 400;
    font-size: 12px;
    margin-bottom: 4px;
    line-height: 18.2px;
    display: block;
  }

  .bank {
    font-weight: 700;
    font-size: 14px;
    margin-top: 4px;
  }

  .row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  @media screen and (max-width: 960px) {
    border-radius: ${(props) =>
      Number(props.theme.radiusCards)
        ? `${props.theme.radiusCards}px`
        : '10px'};
    padding: 24px 20px;
    height: auto;
    justify-content: initial;
    /* flex-direction: column-reverse; */

    .right {
      align-items: flex-start;
    }

    .price {
      font-size: 20px;
      line-height: 20.12px;

      span {
        display: block;
      }
    }

    .portion {
      font-size: 16px;
      line-height: 20.8px;

      #icon {
        display: none;
      }
    }

    .bank {
      margin-bottom: 8px;
    }

    .text {
      display: none;
    }

    .row {
      flex-direction: column-reverse;
    }
  }
`;
export const CpfContainer = styled.div<inputProps>`
  position: relative;
  background: #fff;
  width: 400px;
  height: 68px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${(props) =>
    Number(props.theme.borderRadius)
      ? `${props.theme.borderRadius}px`
      : '16px'};
  padding: 0 10px;
  margin-bottom: 20px;
  border: ${(props) =>
    props.filled && !props.valid
      ? '2px solid #ff5670'
      : props.theme.hasBorder === 'true'
      ? `2px solid ${props.theme.colors.primaryDark1}`
      : '2px solid #fff'};

  input {
    width: 80%;
    height: inherit;
    font-size: 22px;
    font-weight: 400;
    color: #222222;
    border: none;
    background: none;

    ::placeholder {
      color: #7b86a3;
    }
  }

  span {
    width: 10%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  svg {
    color: #24c952;
    font-size: 30px;
    display: ${(props) => (props.filled && props.valid ? 'block' : 'none')};
  }

  .invalidCPF {
    display: ${(props) => (props.filled && !props.valid ? 'block' : 'none')};
    font-size: 14px;
    font-weight: 700;
    color: white;
    position: absolute;
    background: #ff5670;
    border-radius: ${(props) =>
      Number(props.theme.borderRadius)
        ? `${+props.theme.borderRadius + 4}px`
        : '20px'};
    padding: 3px 8px;
    bottom: -12px;
  }

  @media (max-width: 960px) {
    width: 100%;
  }
`;

export const ButtonContainer = styled.div`
  width: 400px;
  height: 68px;

  button {
    height: inherit;
    width: 100%;
    background: ${(props) => props.theme.colors.primary};
    color: #fff;
    font-size: 20px;
    font-weight: 700;
    line-height: 28px;
    border-radius: ${(props) =>
      Number(props.theme.borderRadius)
        ? `${props.theme.borderRadius}px`
        : '16px'};
  }

  @media (max-width: 960px) {
    width: 100%;
  }
`;

export const RightContainer = styled.div`
  display: flex;
  justify-content: center;

  @media screen and (max-width: 960px) {
    margin-top: 45px;
  }
`;

export const Image = styled.img`
  height: 100%;
`;

export const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
  margin-top: 10px;
  width: 400px;

  @media screen and (max-width: 960px) {
    margin-bottom: 50px;
    width: 100%;
  }
`;

export const PaymentCard = styled.div`
  width: 100%;
  height: 68px;
  background: ${(props) => props.theme.colors.white};
  box-shadow: -4px -4px 8px rgba(255, 255, 255, 0.8),
    4px 4px 6px rgba(36, 36, 36, 0.1);
  border-radius: ${(props) =>
    Number(props.theme.radiusCards) ? `${props.theme.radiusCards}px` : '60px'};

  margin-bottom: 12px;
  padding: 20px 32px;
  display: flex;
  justify-content: space-between;

  &:hover {
    cursor: pointer;
  }

  .text {
    padding: 6px 0;
    font-size: 20px;
    color: ${(props) => props.theme.colors.black};
    flex-grow: 10;
    @media screen and (max-width: 960px) {
      padding: 10px 0;
    }
  }

  span {
    flex-grow: 1;
  }

  @media screen and (max-width: 960px) {
    height: 72px;
    border-radius: ${(props) =>
      Number(props.theme.radiusCards)
        ? `${props.theme.radiusCards}px`
        : '10px'};
    padding: 18px;

    .text {
      font-size: 16px;
    }
  }
`;

export const Icon = styled.div`
  color: ${(props) => props.theme.colors.primaryDark2};
  padding: 3px 0;

  @media screen and (max-width: 960px) {
    padding: 6px 0;
  }
`;

export const IconCopyFile = styled(CopyFile)`
  width: 28px;
  height: 28px;

  @media screen and (max-width: 960px) {
    width: 36px;
    height: 36px;
  }
`;

export const IconPrinter = styled(Printer)`
  width: 28px;
  height: 28px;

  @media screen and (max-width: 960px) {
    width: 36px;
    height: 36px;
  }
`;
